import { useQuery } from "@tanstack/react-query";
import { getAllMachineUserApiRequest } from "../../services";
import { useCommonStore } from "../../store";

export const useGetAllMachineUserApi = () => {
  const { reload } = useCommonStore()
  const { data, isLoading } = useQuery({
    queryKey: ["all-machine-user", "all-machine-of-store", "all-machine", reload],
    queryFn: () => getAllMachineUserApiRequest(),
    enabled: true,
  });
  return {
    machines: data,
    isLoading,
  };
};
